import {
  GET_RANK_INFO,
  GET_RANK_EVENTS,
  GET_RANK_BRANDS
} from '../mutiation'
import moment from 'moment'
import { getStar, toThousands } from '@index/config/config'

const state = {
  categories: [],
  times: [],
  events: [],
  brands: []
}

const actions = {}

const mutations = {
  [GET_RANK_INFO] (state, data) {
    state.categories = data.hotCategories
    state.times = data.times
  },
  [GET_RANK_EVENTS] (state, data) {
    state.events = data.map((d, i) => {
      return Object.assign({}, d, {
        no: i < 3 ? require(`@index/assets/img/rank/${i}.png`) : i,
        startTime: moment(d.startTime).format('YYYY/MM/DD'),
        star: getStar(d.crisisLevel),
        interveneHour: `${d.interveneHour}小时`,
        afterNegMedia: `${+d.afterNegMedia.toFixed(1)}%`,
        afterNegWeMedia: `${+d.afterNegWeMedia.toFixed(1)}%`,
        articleCount: toThousands(d.articleCount)
      })
    })
  },
  [GET_RANK_BRANDS] (state, data) {
    state.brands = data.map((d, i) => {
      return Object.assign({}, d, {
        no: i < 3 ? require(`@index/assets/img/rank/${i}.png`) : i,
        startTime: moment(d.startTime).format('YYYY/MM/DD'),
        star: getStar(d.avgCrisisLevel),
        imgUrl: `/app/${d.imgUrl}`
      })
    })
  }
}

const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/rank.js